import React from 'react'
import { useDispatch } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Helmet } from 'react-helmet'

import ScreenAuth from '../ScreenAuth'
import { AppBar } from '../../appBar'
import { Drawer } from '../../drawer'

import { DRAWER_KEYS, DRAWER_WIDTH } from '../../../class/constants'
import { acDrawerToggle } from '../../../class/actions'

import { PanelProduct } from '../../panels'

const ProductScreen = ({ classes }) => {
  const dispatch = useDispatch()

  const pageTitle = 'Produtos';

  return (
    <ScreenAuth>
      <Helmet>
        <title>{pageTitle} | 4KST Consulta</title>
      </Helmet>

      <div className={classes.root}>
        <AppBar onMenuClick={() => dispatch(acDrawerToggle())} />
        <Drawer selectedKey={DRAWER_KEYS.PRODUCTS} />

        <main className={classes.content}>
          <div className={classes.toolbar} />
          <PanelProduct />
        </main>
      </div>
    </ScreenAuth>
  )
}

// It is important to have overflow on both `root` and `content` classes
const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    overflow: 'auto'
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,

    [theme.breakpoints.up('md')]: {
      marginLeft: DRAWER_WIDTH
    }
  },

  toolbar: {
    [theme.breakpoints.down('xl')]: theme.mixins.toolbar
  }
})

export default withStyles(styles)(ProductScreen)